// @ngInject
function ToasterService(toastr) {
    return {
        showSuccess: showSuccess,
        showWarning: showWarning,
        showError: showError,
        showInfo: showInfo
    };

    function showSuccess(message, title, timeOutTimer) {
        if(timeOutTimer !== undefined) {
            toastr.success(message, title, { timeOut: timeOutTimer});
        }else
            toastr.success(message, title);
    }   

    function showWarning(message, title, timeOutTimer) {
        if(timeOutTimer !== undefined) {
            toastr.warning(message, title, {timeOut: timeOutTimer});
        }else
            toastr.warning(message, title);
    }

    function showError(message, title, timeOutTimer) {
        if(timeOutTimer !== undefined) {
            toastr.error(message, title, {timeOut: timeOutTimer});
        }else
            toastr.error(message, title);
    }

    function showInfo(message, title, timeOutTimer) {
        
        if(timeOutTimer !== undefined) {
            toastr.info(message, title, {timeOut: timeOutTimer});
        }else
            toastr.info(message, title);
    }


}


angular
    .module('services.toasterService', [])
    .factory('ToasterService', ToasterService);
